export const mainLinePriorityQuery = {
  bool: {
    should: [{ term: { 'line.main': true } }],
  },
};
